export default "<div class=\"menu-item hover {{class}}\" {{attrIfValue \"id\" id}}>\n    <i class=\"{{symbolClass}}\"></i>\n    {{title}}\n</div>";